<template>
	<s-modal-bottom-sheet
		v-model="show"
		persistent
	>
		<template #activator="{ on }">
			<v-btn
				color="primary"
				outlined
				v-on="on"
			>
				Импорт
			</v-btn>
		</template>

		<v-card>
			<v-form
				v-show="step === 0"
				ref="form"
				:key="formKey"
				@submit.stop.prevent="submit"
			>
				<v-card-text class="pt-5">
					<v-file-input
						ref="fileInput"
						label="Файл"
						name="file"
						outlined
						dense
					/>
					<v-text-field
						value="0"
						type="number"
						name="sheet"
						label="Номер листа"
						outlined
						dense
					/>
					<v-text-field
						value="1"
						type="number"
						label="Номер первой строки"
						name="start_row"
						outlined
						dense
						hide-details
					/>
				</v-card-text>
				<v-card-actions>
					<v-btn
						type="submit"
						color="primary"
						outlined
					>
						Импорт
					</v-btn>
					<v-spacer />
					<v-btn
						outlined
						@click="close"
					>
						Отмена
					</v-btn>
				</v-card-actions>
			</v-form>
			<v-card-title v-show="step === 1">Результат импорта</v-card-title>
			<v-card-text v-show="step === 1" :style="resultStyle">
				<v-list>
					<v-list-item
						v-for="(item, key) in result"
						:key="key"
						dense
					>
						{{ item }}
					</v-list-item>
				</v-list>
			</v-card-text>
			<v-card-actions v-show="step === 1">
				<v-btn
					color="primary"
					outlined
					@click="step = 0"
				>
					Назад
				</v-btn>
				<v-spacer />
				<v-btn
					outlined
					@click="close"
				>
					Закрыть
				</v-btn>
			</v-card-actions>
		</v-card>
	</s-modal-bottom-sheet>
</template>

<script>
import SModalBottomSheet from '@/components/base/s-modal-bottom-sheet';

export default {
	name: 'ImportSeoModal',
	components: { SModalBottomSheet },
	data: () => ({
		show: false,
		loading: false,
		step: 0,
		result: [],
		formKey: 0,
	}),
	computed: {
		resultStyle() {
			return this.$vuetify.breakpoint.xsOnly
				? {
					'max-height': '50vh',
				}
				: {};
		},
	},
	watch: {
		show(val) {
			if (!val) return;

			this.$nextTick(() => {
				const block = this.$refs.fileInput.$el;
				block.querySelector('input[type=file]').click();
			});
		},
	},
	methods: {
		async submit() {
			if (this.loading || !this.$refs.form.validate()) return;
			this.loading = true;
			try {
				const response = await this.$http.post('/api/v1/shop-products/import-seo-data', new FormData(this.$refs.form.$el));
				this.result = response.data.data;
				this.step = 1;
			} catch (e) {
				this.$notify.error('Ошибка импорта');
			} finally {
				this.loading = false;
			}
		},
		close() {
			this.show = false;
			this.$refs.form.reset();
			this.$refs.form.resetValidation();
			this.formKey++;
			this.step = 0;
			this.result = [];
		},
	},
};
</script>

<style scoped>

</style>
